export default __webpack_public_path__ + "static/media/logo.772f2795.png";